import isMentionsNotification from '../../../components/Notifications/helpers/isMentionsNotification';
import { mergeEventIdMaps } from './feedPage';

function cardsById(items = []) {
  const cards = new Map();
  (items || []).forEach((item) => {
    if (!item?._id) {
      return;
    }
    const list = cards.get(item._id);
    if (list) {
      list.push(item);
    } else {
      cards.set(item._id, [item]);
    }
  });
  return cards;
}

function pushId(ids, seen, id) {
  if (!id || seen.has(id)) {
    return;
  }
  seen.add(id);
  ids.push(id);
}

function eventIds(map = {}) {
  const ids = [];
  Object.keys(map || {}).forEach((assetId) => {
    (map[assetId] || []).forEach((id) => {
      if (id) {
        ids.push(id);
      }
    });
  });
  return ids;
}

/**
 * Ids a successful mentions mark-all must commit.
 * Mention cards come from the pre-request snapshot and the latest feed.
 * A highlight id is included when it has no card, or only mention cards.
 * A loaded non-mention card stays restorable.
 */
export default function committedMentionNotificationIds(
  snapshotItems = [],
  latestItems = [],
  snapshotNewComments = {},
  snapshotNewRevisions = {},
  latestNewComments = {},
  latestNewRevisions = {},
  userId,
) {
  const ids = [];
  const seen = new Set();
  const snapshotCards = cardsById(snapshotItems);
  const latestCards = cardsById(latestItems);

  const pushMentionItems = (items = []) => {
    (items || []).forEach((item) => {
      if (item?._id && isMentionsNotification(item, userId)) {
        pushId(ids, seen, item._id);
      }
    });
  };

  pushMentionItems(snapshotItems);
  pushMentionItems(latestItems);

  const highlightIds = [
    ...eventIds(mergeEventIdMaps(snapshotNewComments || {}, latestNewComments || {})),
    ...eventIds(mergeEventIdMaps(snapshotNewRevisions || {}, latestNewRevisions || {})),
  ];

  highlightIds.forEach((id) => {
    const cards = [
      ...(snapshotCards.get(id) || []),
      ...(latestCards.get(id) || []),
    ];
    if (!cards.length || cards.every((card) => isMentionsNotification(card, userId))) {
      pushId(ids, seen, id);
    }
  });

  return ids;
}
